import React from "react";
import { connect } from 'react-redux';
import {sidebarMenu} from "../menu";
import {Link, Switch} from "react-router-dom";
import {
    LockOutlined,
    UserOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined, QuestionCircleOutlined
} from "@ant-design/icons";
import PrivateRoute from "./shared/PrivateRoute";
import GlobalSearch from "./global_search";
import {Loading} from "../libs/loading";
import {Helmet} from "react-helmet";
import {getRootPath} from "../libs/utils";
import {Button, Col, ConfigProvider, Dropdown, Layout, Menu, message, Row, Tooltip, Card} from "antd";
import qs from "qs";
import {getErrorMessage} from "../actions/system";
import Notifications from "./shared/Notifications";
import Announcements from "./shared/Announcements";
import Issues from "./shared/Issues";
import OverdueNotice from "./shared/OverdueNotice";
import AccountManagerProfile from "./account/AccountManagerProfile";
import {hasPermission} from "./permissions/PermissionUtils";
import {FaCrown} from "react-icons/fa";
import {IoBusinessOutline} from "react-icons/io5";
import {toggleSideMenu} from "../actions/app";
import {PageView} from "./PageView";
import SuspendedHostingAccountNotice from "./shared/SuspendedHostingAccountsNotice";
import {startGettingStartedWizard} from "../actions/getting_started_wizard";
import {MobileWarning} from "./shared/MobileWarning";
import LiveChat from "./shared/LiveChat";
import PageSupportModal from "./shared/PageSupportModal";
import TermsOfServiceModal from "./shared/TermsOfServiceModal";
import PrivacyPolicyModal from "./shared/PrivacyPolicyModal";
import {updateAccountSetupTodo, updatePanelMode} from "../actions/account";
import {loadUser} from "../actions/auth";
import PanelModeToggle from "./shared/PanelModeToggle";
import PageHeader from "./shared/PageHeader";


class App extends React.Component {
    state = {
        sideMenuCollapsed: false,
        activeMenuItem: '/',
        activeSubmenuItem: null,
        submenuOpen: false,
        darkMode: false,
        showPageSupportModal: false,
        pageSupportId: null,
        reactivatingTodoList: false,
    };

    componentDidMount() {
        this.updatePage(this.props.location.pathname);

        this.props.history.listen((location) => {
            this.updatePage(location.pathname);
        });

        this.setState({ activeMenuItem: '/' + this.props.location.pathname.split('/')[1]})

        if(this.props.location.search !== '') {
            let parsed = qs.parse(this.props.location.search.substring(1));

            if(typeof parsed.error !== 'undefined') {
                this.props.getErrorMessage(parsed.error, (res) => {
                    message.error(res.data.description, 5000);
                }, () => {});
            }
        }
    }

    updatePage(location) {
        if(typeof location !== 'undefined' && location !== '/auth/logout' && location !== '/auth/login') {
            const rootPath = getRootPath(location);
            this.setState({ activeMenuItem : rootPath, activeSubmenuItem: (rootPath === location ? rootPath : location) });
        }
    }

    getTextFromReact = (element) => {
        if (typeof element === "string") return element;
        if (Array.isArray(element)) return element.map(this.getTextFromReact).join("");
        if (React.isValidElement(element)) return this.getTextFromReact(element.props.children);
        return "";
    }

    render() {
        if(this.props.user === null) {
            return <Loading />;
        }

        const { user } = this.props.user;
        let routes = [];
        const newMenuItems = [];

        Object.keys(sidebarMenu).forEach(path => {
            const item = sidebarMenu[path];
            let allowCustomer = typeof item.allow_customer !== 'undefined' ? item.allow_customer : true;

            if(hasPermission(user.company.permissions, item.scopes)) {
                let showItem = false;

                if(!user.is_customer || allowCustomer) {
                    showItem = true;
                }

                if(showItem && item.mode.includes(this.props.user.user.panel_mode) && this.props.user.user.company.domain_count >= item.min_domain_count) {
                    routes.push(<PrivateRoute key={path} path={path} component={item.page} exact={item.exact} />);

                    if(!item.subpage) {
                        newMenuItems.push({
                            key: path,
                            label: item.name,
                            icon: item.icon,
                        })
                    }
                }
            }
        });

        const userMenuItems = [
            {
                label: 'Panel mode',
                children: [
                    { label: <PanelModeToggle />, key: 'panel-mode'}
                ],
                type: 'group'
            }
        ];

        if(!user.is_customer && hasPermission(user.company.permissions, ['can_switch_companies'])) {

            let companyList = {
                label: 'Your companies',
                children: [],
                type: 'group'
            }

            for(let i = 0; i < user.company_list.length; i++) {
                companyList['children'].push({ label: <Tooltip title='Switch to company' placement='left'>
                        <Link className='user-menu-item' to={'/account/select-company/' + user.company_list[i].guid}>
                            <IoBusinessOutline /> {user.company_list[i].name}
                        </Link>
                </Tooltip>, key: 'switch-company-' + i});
            }

            userMenuItems.push(companyList);

            userMenuItems.push({ type: 'divider' });
        }

        /*userMenuItems.push({ label:  <Link
                className='user-menu-item' to='#'
                onClick={() => this.props.startGettingStartedWizard(this.props.user.user.company.guid)}>
                <FaWandMagicSparkles style={{marginBottom: '-2px'}} /> Getting Started Wizard</Link>, key: 'getting-started-wizard' });*/

        if(!user.is_customer) {
            userMenuItems.push({ label:  <Link className='user-menu-item' to='/account/profile'><UserOutlined /> User Profile</Link>, key: 'user-profile' });
        }

        if(!user.is_customer && hasPermission(user.company.permissions, ['can_view_company_info'])) {
            userMenuItems.push({ label:  <Link className='user-menu-item' to='/company'><IoBusinessOutline style={{marginBottom: '-2px'}} /> Company Profile</Link>, key: 'company-profile' });
            userMenuItems.push({ type: 'divider' });
        }

        userMenuItems.push({ label:  <Link className='user-menu-item' to='/auth/logout'><LockOutlined /> Log Out</Link>, key: 'logout' });

        const { Header, Sider, Content } = Layout;

        const { sideMenuCollapsed } = this.props.app;

        const userHeaderMenuItems = [<div key='user-name'>{user.first_name + ' ' + user.last_name}</div>]

        if(!user.is_customer) {
            userHeaderMenuItems.push(<div key='user-name-partner'><small>{user.company.name}{user.company.is_partner ? <span className='partnership-badge'><FaCrown /></span> : ''}</small></div>);
        }

        let accountManagerProfile = <></>;
        if(this.props.user.user.company.is_partner && !sideMenuCollapsed) {
            accountManagerProfile = <AccountManagerProfile />
        } else if(typeof(this.props.user.user.company.account_manager) !== 'undefined' && !sideMenuCollapsed) {
            accountManagerProfile = <AccountManagerProfile />
        }

        return(
            <ConfigProvider>
                <MobileWarning />

                <Layout className={'main-wrapper' + (this.props.app.darkMode ? ' dark' : '')}>
                    <Sider className='sidebar' trigger={null} width='230px' collapsible collapsed={sideMenuCollapsed}>
                        <div className='sidebar-content'>
                            <Row className={'cursor-pointer header-logo' + (sideMenuCollapsed ? ' collapsed' : '')} align='middle'>
                                <img src={sideMenuCollapsed ? '/img/logo-icon.png' : '/img/logo-light.svg'} alt='Logo' id='logo' onClick={() => this.props.history.push('/')} />
                                {this.props.user.user.panel_mode === 'ADVANCED' && !sideMenuCollapsed ? <span style={{color: '#637dc9', fontStyle: 'italic', fontWeight: 500, marginLeft: '10px'}}>PRO</span> : null}
                            </Row>

                            <div className='sidebar-menu-area'>
                                <Menu items={newMenuItems} selectedKeys={[this.state.activeMenuItem]} onClick={({key}) => {
                                    this.setState({ activeMenuItem: key });

                                    if(key.substring(0, 4) === 'http') {
                                        window.open(key);
                                    } else {
                                        this.props.history.push(key);
                                    }
                                }} theme='light' />
                            </div>

                            {!sideMenuCollapsed ? <Card title='Panel mode' bordered={false} size='small' style={{padding: 0}}>
                                <div className='panel-mode-toggle'>
                                    <PanelModeToggle />
                                </div>
                            </Card> : null}
                            <div className='sidebar-support-area'>
                                {accountManagerProfile}
                            </div>
                        </div>
                    </Sider>
                    <Layout className='layout'>
                        <Header className='header'>
                            <Row justify="space-between" align="middle">
                                <Col xs={2} md={1}>
                                    <div className='sidemenu-collapse'>
                                        <Tooltip
                                            title={sideMenuCollapsed ? 'Expand sidebar menu' : 'Collapse sidebar menu'}>
                                            {React.createElement(sideMenuCollapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                                                className: 'trigger',
                                                onClick: () => this.props.toggleSideMenu(),
                                            })}
                                        </Tooltip>
                                    </div>
                                </Col>
                                <Col xs={9} md={19}>
                                    <div className='header-search'>
                                        <GlobalSearch/>
                                    </div>
                                </Col>
                                <Col xs={13} md={4}>
                                    <div className='header-actions'>
                                        <Row>
                                            {!user.is_customer ? <Col xs={7} md={4}><Notifications/></Col> : ''}
                                            <Col xs={17} md={20}>
                                                <Dropdown menu={{items: userMenuItems}}>
                                                    <Button type='text' className='header-user-info'
                                                            onClick={e => e.preventDefault()}>
                                                        {userHeaderMenuItems.map(item => item)}
                                                    </Button>
                                                </Dropdown>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </Header>
                        <Content className='main' onClick={() => this.state.sidebarMenuOpen ? this.setState( { sidebarMenuOpen: false }) : null}>
                            <div className='main-header'>
                                {this.props.page.title ? <Helmet>
                                    <title>{this.getTextFromReact(this.props.page.title)}</title>
                                </Helmet> : null}
                                {!this.props.page.hideTitle ? <Row gutter={[16, 16]} justify='space-between' align='middle'>
                                    <Col>
                                        <PageHeader title={this.props.page.title} history={this.props.history} />
                                    </Col>
                                    <Col>{this.props.page.supportId !== null ? <Tooltip placement='left' title='Info about this page'><Button onClick={() => this.setState({ showPageSupportModal: true, pageSupportId: this.props.page.supportId })} type='text' shape="circle" icon={<QuestionCircleOutlined />} /></Tooltip> : ''}</Col>
                                </Row> : null}
                            </div>
                            <div className='main-content'>
                                {!user.is_customer ? <Announcements /> : ''}
                                <Issues />
                                {!user.is_customer ? <OverdueNotice /> : ''}
                                {!user.is_customer ? <SuspendedHostingAccountNotice /> : ''}
                                <div className='body-container'>
                                    <PageView />
                                    <Switch>
                                        {routes}
                                    </Switch>
                                </div>
                            </div>
                        </Content>
                    </Layout>
                </Layout>

                <PageSupportModal
                    onClose={() => this.setState({ showPageSupportModal: false, supportId: null })}
                    show={this.state.showPageSupportModal}
                    supportId={this.state.pageSupportId} />

                {this.props.user.review_terms_of_service ? <TermsOfServiceModal /> : ''}
                {this.props.user.review_privacy_policy ? <PrivacyPolicyModal /> : ''}

                {/*this.props.wizard && <GettingStartedWizard history={this.props.history} />*/}
                {/*this.props.wizard?.isMinimized && <GettingStartedWizardFloater />*/}

                <LiveChat />
            </ConfigProvider>
        );
    }
}

const mapStateToProps = state => ({
    wizard: state.getting_started_wizard,
    user: state.auth.user,
    page: state.page,
    app: state.app
});

export default connect(mapStateToProps, { getErrorMessage, toggleSideMenu, startGettingStartedWizard,
    updateAccountSetupTodo, loadUser, updatePanelMode })(App);